import React, { useEffect, useState } from "react"
import "./Question.css";
import { useSelector } from "react-redux";
import { selectTranslations } from "../../../services/i18n/i18nSlice";
import { Form, OverlayTrigger, Popover, FormCheck } from "react-bootstrap";

import correct_img from '../../../assets/images/questions/correct.svg'
import wrong_img from '../../../assets/images/questions/wrong.svg'
import missing_img from '../../../assets/images/questions/missing.svg'
import light_img from '../../../assets/images/questions/light.svg'
import { TitleH3 } from "../../../components/TitleH3";
import { API_URL } from "../../../config/constants";

import Zoom from 'react-medium-image-zoom'
import 'react-medium-image-zoom/dist/styles.css'
import SecureImage from "../../../components/_partials/SecuredImage";
import { isMobile } from "react-device-detect";
import { Text } from "../../../components/Text";
import { isCorrectAnswer } from "../examUtils";
import { TitleH1 } from "../../../components/TitleH1";
import dotsIcon from "../../../assets/images/questions/tripledots.svg";
import PaperPreview from "../../../components/PaperPreview/PaperPreview";

export default function QuestionReview(props){

    const t = useSelector(selectTranslations)
    const [HasAnswer,setHasAnswer] = useState(false)
    const [imageLoaded, setImageLoaded] = useState(false)

    const formatText = (original_text = "") => {
        return original_text?.replaceAll("\n", '<br />')?.replaceAll("$$","$")
    }

    const renderQuestionText = (text) => {
        try {
            if (!text) return '';

            // eslint-disable-next-line no-useless-escape
            const blankPattern = /\[(?::blank:|\.\.\.|\_{3,})\]/i;
            const parts = text.split(blankPattern);

            if (parts.length <= 1) {
                return (
                    <p className="mt-3" dangerouslySetInnerHTML={{ __html: text }} />
                );
            }

            return (
                <p className='question-text-inline mt-3'>
                    {parts.map((part, index) => (
                        <React.Fragment key={index}>
                            {part && part.trim() && (
                                <span dangerouslySetInnerHTML={{ __html: part }} />
                            )}
                            {index < parts.length - 1 && (
                                <img
                                    src={dotsIcon}
                                    alt='[blank]'
                                    className='question-mark-icon-inline'
                                />
                            )}
                        </React.Fragment>
                    ))}
                </p>
            );
        } catch (error) {
            console.warn('Error in renderQuestionText:', error);
            return <p className="mt-3" dangerouslySetInnerHTML={{ __html: text }} />
        }
    };

    useEffect(()=>{
        setImageLoaded(false)
    },[props?.data?.image_url])

    return (
        <div className="col-12 col-md-9 exam_question_container px-3 px-md-4 pb-5">
            {
                props.data? 
                    <>
                        <TitleH1>{t.exam.questions_review}</TitleH1>
                        {!isMobile ? <Text className="question_number">{t.question.question} {parseInt(props.data.virtual_question_number)} </Text> : null}
                        {props.data.isBlockQuestion && props.data.parent_text && props.data.parent_text !== props.data.text ?
                            <div className="block_parent_text">{renderQuestionText(props.data.parent_text)}</div>
                        : null}
                        {renderQuestionText(props.data.text)}
                        {
                            props.data.paper && props.data.virtual_question_number != undefined ?
                                <PaperPreview paper={props.data.paper} onOpenFullscreen={props.handleOpenReader} />
                            : ""
                        }
                        { props.data.image_url ?
                            <> 
                                <Zoom>
                                    <SecureImage src={props.data.image_url} alt="Question Image" className="mt-3" />
                                </Zoom>
                                
                                <small className="d-block text-secondary">{t.question.click_on_image}</small>
                            </>
                        : ""}
                        {
                            props.data.additional_material_instructions ? <p className="mt-2 text-secondary">{props.data.additional_material_instructions}</p> : ""
                        }
                        <Text className="mb-0 mt-4">{ props.data?.question_type === "multi" || props.data?.question_type === "survey" ? t.question.your_answers : t.question.your_answer}</Text>
                        <div className="answers_list">
                            {props.data.question_type === "fill" && props.data.selected_answer_text && (
                                <label className={`answer ${isCorrectAnswer(props.data) ? "correct_answer" : "wrong_answer"}`}>
                                    <FormCheck>
                                        <FormCheck.Input type="radio" className="hidden_radio" readOnly checked={true} />
                                        <img src={isCorrectAnswer(props.data) ? correct_img : wrong_img} alt="" />
                                        <FormCheck.Label>{props.data.selected_answer_text}</FormCheck.Label>
                                    </FormCheck>
                                </label>
                            )}
                            {props.data.answers.map((answer) => {
                                if(( props.data.selected_answer_numbers && props.data?.selected_answer_numbers?.includes(parseInt(answer.answer_number)) )  || (answer.answer_number == props?.data?.selected_answer_number))
                                    return (
                                        <label className={"answer " + (answer.is_correct_answer ? "correct_answer" : "wrong_answer")}  key={answer.answer_number} >
                                            
                                            <FormCheck>
                                                <FormCheck.Input  
                                                    type={"radio"}
                                                    className="hidden_radio"
                                                    name={`answer-${props.data.question_number}-${answer.answer_number}`}
                                                    id={`answer-${props.data.question_number}-${answer.answer_number}`}
                                                    value={answer.answer_number} 
                                                    readOnly
                                                    checked={props.data.selected_answer_numbers !== null && props.data.selected_answer_numbers?.includes(parseInt(answer.answer_number)) ? true : false}
                                            />
                                                { answer.is_correct_answer ? <img src={correct_img} /> : <img src={wrong_img} /> }
                                                <FormCheck.Label htmlFor={`answer-${props.data.question_number}-${answer.answer_number}`} dangerouslySetInnerHTML={{ __html: answer.text }} />
                                            </FormCheck>
                                        </label>
                                    )
                            })}
                            {
                                (props.data.question_type === "fill" && !props.data?.selected_answer_text) || props.data?.selected_answer_number === null || (props.data?.selected_answer_numbers && props.data?.selected_answer_numbers?.length === 0 ) ?
                                <label className={"answer missing_answer"}  >       
                                    <FormCheck>
                                        <FormCheck.Input  
                                            type={"radio"}
                                            className="hidden_radio"
                                            name={`answer-missing`}
                                            id={`answer-missing`}
                                            readOnly
                                    />
                                        <img src={missing_img} />
                                        <FormCheck.Label dangerouslySetInnerHTML={{ __html:t.question.missing_answer }} />
                                    </FormCheck>
                                </label> : null
                            }
                        </div>
                        {
                            !isCorrectAnswer(props.data) ?
                        <>
                        <Text className="mb-0 mt-4">{props.data?.question_type === "multi" || props.data?.question_type === "survey" ? t.question.correct_answers : t.question.correct_answer}</Text>
                        <div className="answers_list">
                            {props.data.answers.map((answer) => {
                                if( answer.is_correct_answer && ((!props.data?.selected_answer_numbers?.includes(parseInt(answer.answer_number)) ) && (answer.answer_number !== props?.data?.selected_answer_number)))
                                    return (
                                        <label className={"answer correct_answer"} key={answer.answer_number}>
                                            
                                            <FormCheck>
                                                <FormCheck.Input  
                                                    type={"radio"}
                                                    className="hidden_radio"
                                                    name={`answer-${props.data.question_number}-${answer.answer_number}`}
                                                    id={`answer-${props.data.question_number}-${answer.answer_number}`}
                                                    value={answer.answer_number} 
                                                    readOnly
                                                    checked={props.data.selected_answer_numbers !== null && props.data.selected_answer_numbers?.includes(parseInt(answer.answer_number)) ? true : false}
                                            />
                                                <img src={correct_img} />
                                                <FormCheck.Label htmlFor={`answer-${props.data.question_number}-${answer.answer_number}`} dangerouslySetInnerHTML={{ __html: answer.text }} />
                                            </FormCheck>
                                        </label>
                                    )
                            })}
                        </div>
                        </> : null }
                        {
                            props.data?.pill ?
                                <div className="question_pill mt-4">
                                    {
                                        props.data.pill.image_url &&
                                            <SecureImage imageUrl={`${API_URL}${props.data.pill.image_url}`} className="w-100" />
                                    }
                                    <div className='d-flex mb-2 align-items-center'>
                                        <img src={light_img} />
                                        <TitleH3 className='ms-2 mb-0'>{t.question.pill}</TitleH3>
                                    </div>
                                    <p className='pill_text mb-0' style={{fontWeight: 400}}>
                                        {props.data.pill?.text}
                                    </p>
                                </div>
                            : null
                        }
                    </>
                : ""
            }
        </div>
    )
}